import * as React from 'react';

import PropTypes from 'prop-types';

export type ProgramScope = { programScope: { isProgramScope: boolean; programIds: string[] } };

export const connectToProgramScope = <PropsFromCaller extends {}>(
  Component: React.ComponentType<PropsFromCaller & ProgramScope>
): React.ComponentType<PropsFromCaller> => {
  const componentName = Component.displayName || Component.name;

  return class extends React.Component<PropsFromCaller> {
    static displayName = componentName + 'ProgramScopeConnector';

    static contextTypes = {
      programScope: PropTypes.object,
    };

    declare context: ProgramScope;

    render() {
      const { programScope } = this.context;
      if (!programScope || !programScope.programIds) {
        throw new Error(
          `${componentName} is attempting to access program scope from context without it being defined. Verify you called withProgramScopeContext before using connectToProgramScope.`
        );
      }
      return <Component {...this.props} programScope={programScope} />;
    }
  };
};

type ProgramScopeContext = {
  isProgramScope: boolean;
  programIds?: string[];
};

export const withProgramScopeContext =
  <Props extends object>(getContextFromPropsFn: (props: Props) => ProgramScopeContext) =>
  (Component: React.ComponentType<Props>) => {
    const componentName = Component.displayName || Component.name;
    return class extends React.Component<Props> {
      static displayName = componentName + 'WithProgramScopeContext';

      static childContextTypes = {
        programScope: PropTypes.object,
      };

      getChildContext = () => {
        const { isProgramScope, programIds = [] } = getContextFromPropsFn(this.props);
        return {
          programScope: {
            isProgramScope,
            programIds,
          },
        };
      };

      render() {
        return <Component {...this.props} />;
      }
    };
  };

export const mapProgramToProgramScopeProps = ({ program }: { program: { id: string } }) => ({
  isProgramScope: true,
  programIds: [program.id],
});
